import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Breadcrumb.scss";
import CancelDialog from "./CancelDialog"; // Import CancelDialog component

const Breadcrumb = ({ currentStep, changeCurrentStep }) => {
  const navigate = useNavigate();
  const [openCancelDialog, setOpenCancelDialog] = useState(false); // State for controlling the dialog
  const showCancelLink = ["/plan/new"];
  const [planName, setPlanName] = useState(localStorage.getItem("plan_name"));

  useEffect(() => {
    const handleStorageChange = (event) => {
      setPlanName(localStorage.getItem('plan_name'));
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const createPlanBreadCrumList = [
    { label: "Control panel" },
    { label: "Subscription", link: "/plans" },
    { label: "Create plan" }
  ];

  const sunbscriptionBreadCrumList = [
    { label: "Control panel" },
    { label: "Subscription" }
  ];

  const viewSubscriptionBreadCrunList = (planName) => {
    return [
      { label: "Control panel" },
      { label: "Subscription", link: "/plans" },
      { label: `${planName}` }
    ];
  };

  const getItemList = () => {
    if (window.location.pathname === "/plans") return sunbscriptionBreadCrumList;
    if (window.location.pathname === "/plan/new") return createPlanBreadCrumList;
    if (window.location.pathname.includes("/plan/view/")) {
      return viewSubscriptionBreadCrunList(planName);
    }
    return [];
  };

  const handleCancelClick = () => {
    setOpenCancelDialog(true);
  };

  const handleCancelConfirm = () => {
    navigate(-1);
    changeCurrentStep(0)
  };

  const handleCancelClose = () => {
    setOpenCancelDialog(false);
  };

  return (
    <div className="BreadcrumContainer">
      <div className="Breadcrumb">
        {getItemList()?.map((item, index) => (
          <React.Fragment key={index}>
            {item.link ? (
              <Link to={item.link} className="BreadcrumbLink">
                {item.label}
              </Link>
            ) : (
              <span className="Breadcrumb-current">{item.label}</span>
            )}
            {index < getItemList()?.length - 1 && (
              <span className="Breadcrumb-separator"> &gt; </span>
            )}
          </React.Fragment>
        ))}
      </div>
      {showCancelLink.includes(window.location.pathname) && currentStep < 4 && (
        <span className="cancelplan" onClick={handleCancelClick}>
          Cancel
        </span>
      )}
      {openCancelDialog && <CancelDialog
        open={openCancelDialog}
        onClose={handleCancelClose}
        onConfirm={handleCancelConfirm}
      />}
    </div>
  );
};

export default Breadcrumb;
